const PlanetsSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='43.522' height='15.702' viewBox='0 0 43.522 15.702' {...props}>
    <path
      id='Path_30793'
      data-name='Path 30793'
      d='M1162.611,662.365h5.6v-4.383l3.634-.282.41-1.019,1.518,4.912,1.371,1.823.012.016,4.561-1.947.03-.013-1.384-1.837-1.536-4.971V653.38h1.749v-.371h7.59v-.337h1.716v.123l.159.511h8.292l.158-.5v-2.058l-.159-.511h-8.292l-.158.5v.131h-1.716v-.337h-7.59v-.372h-1.75v-2.431h-.949l-1.261,1.261-2.339,0-.271.271H1164.2l-.674.674-10.553.01v7.607h1.427l1.17-1.17,3.789-3.154h3.544l.81,2.216v.988l.721.721-1.818,1.819Z'
      transform='translate(-1152.969 -647.729)'
      fill='currentColor'
    />
  </svg>
);
export default PlanetsSvg;
